/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Meta_TitleInputs */

const en_tut_meta_title = /** @type {(inputs: Tut_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutorial — every Bystep mode, step by step`)
};

const id_tut_meta_title = /** @type {(inputs: Tut_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutorial — semua mode Bystep, langkah demi langkah`)
};

/**
* | output |
* | --- |
* | "Tutorial — every Bystep mode, step by step" |
*
* @param {Tut_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_meta_title = /** @type {((inputs?: Tut_Meta_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Meta_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_meta_title(inputs)
	return en_tut_meta_title(inputs)
});